import { __decorate } from "tslib";
import { Component, Emit, Prop, Vue } from "vue-property-decorator";
let Tabs = class Tabs extends Vue {
    value;
    tabs;
    emitInput(val) {
        return val;
    }
    setTab(val) {
        this.emitInput(val);
    }
};
__decorate([
    Prop({ type: String, required: true })
], Tabs.prototype, "value", void 0);
__decorate([
    Prop({ type: Array, required: true })
], Tabs.prototype, "tabs", void 0);
__decorate([
    Emit('input')
], Tabs.prototype, "emitInput", null);
Tabs = __decorate([
    Component({})
], Tabs);
export default Tabs;
